import React from "react";
import axios from "axios";
import { withRouter } from "react-router-dom";
import { css } from "aphrodite";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faTrashAlt,
    faPencilAlt,
    faEdit
} from "@fortawesome/free-solid-svg-icons";
import { validateToken, callApi } from "../../lib/utils";
import { connect } from "react-redux";
import styles from "./style";
import { Row, Card, Col, Button, Modal, Form } from "react-bootstrap";
import async from "async";
import moment, { duration } from "moment";
import Footer from "../GenericComponents/Footer";
import CustomModal from "../GenericComponents/CustomModal";
import CustomLoader from "../GenericComponents/CustomLoader";
import SideDetails from "../GenericComponents/SideDetails";
import SelectField from '../GenericComponents/SelectField';
import SideMenuComponentsHeader from "../GenericComponents/Headers/SideMenuComponentsHeader";
import GeofenceCircleArea from "../GenericComponents/MapComponents/GeofenceCircleArea";
import GeofenceRectangleArea from "../GenericComponents/MapComponents/GeofenceRectangleArea";
import CustomRadioButton from "../GenericComponents/CustomRadioButton";
import GlobalSlider from "../GenericComponents/GlobalSlider";
import GeofenceSettingsModal from "./GeofenceSettingsModal";
import "./GeofenceSettings.css";

class GeofenceSettings extends React.Component {
    constructor(props) {
        super();
        this.state = {
            openGeofenceSettingsModal: false,
            showDeleteModal: false,
            customModalMessage: "",
            customModalErrorMessage: "",
            showCustomModal: false,
            showCustomErrorModal: false,
            showCustomSettingsModal: false,
            loading: false,
            circleData: {},
            boundsData: {},
            fenceType: "",
            geoLocations: [],
            updateFlag: false,
            updatedData: {},
            locationData: props.geoLocationSettings.enableLocationAccess,
            refreshRate: props.geoLocationSettings.locationTrackingInterval / 60,
            duration: props.geoLocationSettings.liveLocationTrackingDuration / 60,
            geoLocationAlertTypeOptions: [
                { id: "IN_FENCE", name: "When entering the specified location" },
                { id: "OUT_FENCE", name: "When outside the specified location" },
            ],
            durationOptions: [
                { id: 3, name: "3 minutes" },
                { id: 5, name: "5 minutes" },
            ],
            refreshRateOptions: [
                { id: 5, name: "5 minutes" },
                { id: 10, name: "10 minutes" },
                { id: 15, name: "15 minutes" },
            ],
            patientContacts: [],
        };
    }

    componentDidMount() {
        validateToken((err) => {
            if (err) {
                window.location = "/logout";
            }
            const hasGpsSubscription = this.props.appModules?.active?.GPS?.includes(
                "GEO_LOCATION_TRACKING",
            );
            if (hasGpsSubscription) {
                this.setState({ loading: true });
                this.fetchGeoLocationSettings();
                this.fetchGeoLocationData();
                this.fetchContacts();
            }
        });
    }

    fetchGeoLocationSettings = () => {
        callApi("/api/patient/geo-location/settings", {}, "GET")
            .then((response) => {
                const geoLocationSettings = response?.data?.data?.geoLocationSetting;
                if (response.status !== 200 || !geoLocationSettings) return;
                this.props.setGeoLocationSettings(geoLocationSettings);
                this.setState({
                    locationData: geoLocationSettings.enableLocationAccess,
                    refreshRate: geoLocationSettings.locationTrackingInterval / 60,
                    duration: geoLocationSettings.liveLocationTrackingDuration / 60,
                });
            })
            .catch((err) => {
                console.log("err: ", err);
            });
    };

    fetchGeoLocationData = () => {
        //this.setState({ loading: true });
        callApi(`/api/patient/geo-location/saved-locations`, {}, "GET")
            .then((response) => {
                this.setState({
                    loading: false,
                    geoLocations: response.data.data.locations,
                })
            })
            .catch((err) => {
                console.log("err: ", err);
                this.setState({
                    loading: false,
                });
            });
    };

    fetchContacts = () => {
        callApi(`/api/web/patient/contacts/list`, {}, "GET")
            .then((response) => {
                let contacts = response.data.data.contacts;
                let alertContactList = [];
                let newAlertContactList = [];
                let patientContacts = [];
                contacts.filter((val) => {
                    return val.enableGeoFenceAlert;
                }).forEach((cont) => {
                    let contact = {
                        label: `${cont.firstName} ${cont.lastName}`,
                        value: cont.id,
                        phoneNumber: cont.phoneNumber
                    }
                    alertContactList.push(contact);
                })

                contacts.filter((val) => {
                    return !val.enableGeoFenceAlert;
                }).forEach((cont) => {
                    let contact = {
                        label: `${cont.firstName} ${cont.lastName}`,
                        value: cont.id,
                        phoneNumber: cont.phoneNumber
                    }
                    newAlertContactList.push(contact);
                })

                patientContacts.alertContactList = alertContactList;
                patientContacts.newAlertContactList = newAlertContactList;
                this.setState({ patientContacts, loading: false });
            })
            .catch((err) => {
                console.log("err: ", err);
                this.setState({
                    loading: false,
                });
            });
    };

    handleUpdateModal = (data) => {
        let circleData = {};
        let boundsData = {};
        if (data.fenceType === "CIRCLE") {
            circleData = data.geoFenceData
        } else {
            boundsData = data.geoFenceData;
        }
        //console.log("circleData...",circleData)
        //console.log("boundsData...",boundsData)

        this.setState({
            openGeofenceSettingsModal: !this.state.openGeofenceSettingsModal,
            fenceType: data.fenceType,
            circleData,
            boundsData,
            updatedData: {
                ...data,
                monitoringMode: data?.monitoringMode === "ALWAYS" ? "ALWAYS" : "SCHEDULED",
            },
            updateFlag: true
        })
    }

    updateGeoLocationData = (data) => {
        const isAlwaysOn = data.monitoringMode === "ALWAYS";
        const params = {
            locationName: data.locationName,
            fenceType: data.fenceType,
            fenceAlertType: data.fenceAlertType,
            monitoringMode: isAlwaysOn ? "ALWAYS" : "SCHEDULED",
            ...(isAlwaysOn
                ? {}
                : {
                    fenceAlertDays: data.fenceAlertDays,
                    fenceAlertTiming: data.fenceAlertTiming,
                }),
            geoFenceData: data.fenceType === "CIRCLE" ? {
                "center": {
                    "lat": data.geoFenceData.center.lat,
                    "lng": data.geoFenceData.center.lng
                },
                "radius": data.geoFenceData.radius
            } : {
                "east": data.geoFenceData.east,
                "west": data.geoFenceData.west,
                "north": data.geoFenceData.north,
                "south": data.geoFenceData.south
            },
            alertContacts: data.alertContacts,
            //newAlertContacts: data.newAlertContacts
        };
        this.setState({ loading: true });
        validateToken((err) => {
            if (err) {
                window.location = "/logout";
            }
            callApi(`/api/patient/geo-location/saved-locations/${data.locationId}`, params, "PUT")
                .then((response) => {
                    if (response.status === 200) {
                        this.setState({
                            loading: false,
                            showCustomModal: true,
                            customModalMessage: "Geo Location updated successfuly !"
                        }, () => {
                            this.fetchGeoLocationData();
                        })
                    } else if (response.status === 400) {
                        this.setState({
                            loading: false,
                            showCustomErrorModal: true,
                            customModalErrorMessage: response.message
                        })
                    }
                })
                .catch((err) => {
                    console.log("err: ", err);
                    this.setState({
                        showCustomErrorModal: true,
                        loading: false,
                        customModalErrorMessage:
                            err.statusCode !== 500 ? err.message : "something went wrong!",
                    });
                });
        });
    }

    saveGeoLocationData = (paramsData) => {
        this.setState({ loading: true });
        validateToken((err) => {
            if (err) {
                window.location = "/logout";
            }
            callApi(`/api/patient/geo-location/saved-locations`, paramsData, "POST")
                .then((response) => {
                    if (response.status === 200) {
                        this.setState({
                            loading: false,
                            showCustomModal: true,
                            customModalMessage: "Geo Location saved successfuly !"
                        }, () => {
                            this.fetchGeoLocationData();
                        })
                    } else if (response.status === 400 || response.statusCode === 400) {
                        this.setState({
                            loading: false,
                            showCustomErrorModal: true,
                            customModalErrorMessage: response.message
                        })
                    }
                })
                .catch((err) => {
                    console.log("err: ", err);
                    this.setState({
                        showCustomErrorModal: true,
                        loading: false,
                        customModalErrorMessage:
                            err.statusCode !== 500 ? err.message : "something went wrong!",
                    });
                });
        });
    };

    handleCustomModal = () => {
        this.setState({ showCustomModal: false, openGeofenceSettingsModal: false });
    };

    handleCustomErrorModal = () => {
        this.setState({ showCustomErrorModal: false });
    };

    handleGeofenceDialog = () => {
        this.setState({
            openGeofenceSettingsModal: !this.state.openGeofenceSettingsModal,
            circleData: {},
            boundsData: {},
            fenceType: "",
            updatedData: {},
            updateFlag: false
        })
    }

    handleDeleteModal = () => {
        this.setState({ showDeleteModal: !this.state.showDeleteModal });
    };

    openDeleteModal = (location) => {
        let element = (
            <div>
                <Modal.Header closeButton>
                    <Modal.Title>Confirm</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Do you want to delete the location <b>{location.locationName}</b> ?
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => this.handleDeleteModal()}>
                        No
                    </Button>
                    <Button variant="primary" onClick={() => this.deleteGeoLocation(location)}>
                        Yes
                    </Button>
                </Modal.Footer>
            </div>
        );

        this.setState({
            showDeleteModal: !this.state.showDeleteModal,
            element,
        });
    };

    deleteGeoLocation = (data) => {
        this.setState({ loading: true });
        validateToken((err) => {
            if (err) {
                window.location = "/logout";
            }
            callApi(
                `/api/patient/geo-location/saved-locations/${data.id}`,
                {},
                "Delete"
            )
                .then((response) => {
                    this.setState({ loading: false, showCustomModal: true, customModalMessage: "location deleted successfully !" }, () => {
                        this.handleDeleteModal();
                        this.fetchGeoLocationData();
                    });
                })
                .catch((err) => {
                    this.handleDeleteModal();
                    this.setState({
                        showCustomModal: true,
                        loading: false,
                        customMessage:
                            err.statusCode !== 500 ? err.message : "something went wrong!",
                    });
                });
        });
    };

    updateSettings = (isIOS) => {
        let params = {
            "enableLocationAccess": isIOS ? this.state.locationData : null,
            "locationTrackingInterval": isIOS ? this.state.refreshRate * 60 : null,
            "liveLocationTrackingDuration": this.state.duration * 60
        };
        this.setState({ loading: true });
        validateToken((err) => {
            if (err) {
                window.location = "/logout";
            }
            callApi("/api/patient/geo-location/settings", params, "PUT")
                .then((response) => {
                    // let geoLocationSettings = {};
                    // if (response.status === 200)
                    //     geoLocationSettings = response.data.data.geoLocationSetting;
                    // //else if(response.status === 400 || response.statusCode === 400)
                    // this.setState({
                    //     geoLocationSettings,
                    // });
                    this.setState({ loading: false });
                    this.fetchGeoLocationSettings();
                })
                .catch((err) => {
                    console.log("err: ", err);
                    this.setState({ loading: false });
                });
        })
    }

    handleChanges = (fieldName, value) => {
        let locationData = value.target.checked;
        if (locationData)
            this.setState({ locationData });
        else
            this.setState({ showCustomSettingsModal: !locationData });
    };

    handleCustomSettingsModal = (fieldName, value) => {
        let showCustomSettingsModal = false;
        let locationData = !value;
        this.setState({ showCustomSettingsModal, locationData });
    };

    handleSelectChange = (e) => {
        let duration = e.target.value;
        this.setState({ duration })
    };

    handleRefreshRateValues = (e) => {
        let refreshRate = e.target.value;
        this.setState({ refreshRate });
    };

    fetchAlertDays = (location) => {
        // let days = [];
        // location.fenceAlertDays.sort().map((value) => {
        //     this.props.days.map((day) => {
        //         if (day.key === value)
        //             days.push(day.label);
        //     })
        //     return days;
        // });

        const alertDays = [...(location.fenceAlertDays || [])].sort();
        return (
            alertDays.map((day, index) => {
                return (
                    <>
                        <span>{moment().day(day).format('ddd')}</span>
                        {index !== alertDays.length - 1 && < span > {" , "}</span >}
                    </>
                )
            })
        )
    }

    render() {
        const { user, appModules } = this.props;
        const isReadOnly = user?.roleId === 10;
        const isIOS = user?.deviceType === 1 || user?.deviceType === "1";
        const trackingEnabled = isIOS ? this.state.locationData : true;
        const hasGpsSubscription = appModules?.active?.GPS?.includes(
            "GEO_LOCATION_TRACKING",
        );
        return (
            <container>
                <CustomLoader loading={this.state.loading} />
                <SideMenuComponentsHeader title={"Monitoring Settings"} />
                <CustomModal
                    header={""}
                    name={""}
                    size={"sm"}
                    title={this.state.customModalMessage}
                    show={this.state.showCustomModal}
                    confirmButtons={false}
                    action={this.handleCustomModal}
                />
                <CustomModal
                    header={""}
                    name={""}
                    size={"sm"}
                    title={this.state.customModalErrorMessage}
                    show={this.state.showCustomErrorModal}
                    confirmButtons={false}
                    action={this.handleCustomErrorModal}
                />
                <CustomModal
                    header={"Are you sure?"}
                    name={""}
                    size={"md"}
                    title={"Disabling this feature will stop the collection of location data. Are you sure you want to continue?"}
                    show={this.state.showCustomSettingsModal}
                    action={this.handleCustomSettingsModal}
                />
                <Modal
                    show={this.state.showDeleteModal}
                    onHide={this.handleDeleteModal}
                    backdrop="static"
                    keyboard={false}
                >
                    {this.state.element}
                </Modal>
                <GeofenceSettingsModal
                    open={this.state.openGeofenceSettingsModal}
                    handleClose={this.handleGeofenceDialog}
                    saveGeoLocationData={this.saveGeoLocationData}
                    updateGeoLocationData={this.updateGeoLocationData}
                    circleData={this.state.circleData}
                    fenceType={this.state.fenceType}
                    boundsData={this.state.boundsData}
                    updatedData={this.state.updatedData}
                    updateFlag={this.state.updateFlag}
                    geoLocationAlertTypeOptions={this.state.geoLocationAlertTypeOptions}
                    patientContacts={this.state.patientContacts}
                    deviceType={this.props.user.deviceType}
                />
                <div>
                    <Row className={css(styles.mainGrid)}>
                        <Col xs={12} md={3} className={css(styles.sideStyle)}>
                            <SideDetails />
                        </Col>
                        <Col xs={12} md={9}>
                            <div className="geofence-settings-content">
                                <div className={css(styles.header)}>
                                    <div>
                                        {"Geo Location Data Settings"}
                                    </div>
                                </div>
                                {!hasGpsSubscription ? (
                                    <div
                                        style={{
                                            fontSize: "16px",
                                            textTransform: "capitalize",
                                            color: "red",
                                            padding: "1em 0",
                                        }}
                                    >
                                        <label>
                                            Not included in your current subscription plan
                                        </label>
                                    </div>
                                ) : (
                                    <>
                                <div className="geofence-panel">
                                    <div className="geofence-section-label">
                                        Live Location Tracking
                                    </div>
                                    <div className="geofence-duration-row">
                                        <div className="geofence-field">
                                            <label className="geofence-field-label">
                                                Track Location For
                                            </label>
                                            <SelectField
                                                name={"duration"}
                                                options={this.state.durationOptions}
                                                value={this.state.duration}
                                                action={this.handleSelectChange}
                                                disabled={isIOS && !this.state.locationData}
                                                className="geofence-select-field"
                                            />
                                            <p className="geofence-helper-text">
                                                Set the duration for which the user&apos;s device location will be actively tracked during each session.
                                            </p>
                                        </div>
                                        {!isIOS && !isReadOnly && (
                                            <div className="geofence-update-btn geofence-update-btn-inline">
                                                <Button onClick={() => this.updateSettings(isIOS)}>
                                                    Save Changes
                                                </Button>
                                            </div>
                                        )}
                                    </div>

                                    {isIOS && (
                                        <>
                                            <div className="geofence-section-divider" />
                                            <div className="geofence-section-label">
                                                Geo Location Tracking
                                            </div>
                                            <div className="geofence-setting-row">
                                                <div className="geofence-toggle-copy">
                                                    <div className="geofence-toggle-label">
                                                        Enable Geo Location Tracking
                                                    </div>
                                                    <p className="geofence-helper-text">
                                                        When enabled, the user&apos;s iOS device will send location updates at the refresh rate set below. Applies to iOS devices only.
                                                    </p>
                                                </div>
                                                <CustomRadioButton
                                                    name={"locationData"}
                                                    type={"switch"}
                                                    inline={true}
                                                    label={""}
                                                    checked={this.state.locationData}
                                                    action={this.handleChanges}
                                                    disabled={isReadOnly}
                                                />
                                            </div>

                                            {trackingEnabled && (
                                                <div className="geofence-duration-row">
                                                    <div className="geofence-field">
                                                        <label className="geofence-field-label">
                                                            Geo Location Refresh Rate (Minutes)
                                                        </label>
                                                        <SelectField
                                                            name={"refreshRate"}
                                                            options={this.state.refreshRateOptions}
                                                            value={this.state.refreshRate}
                                                            action={this.handleRefreshRateValues}
                                                            className="geofence-select-field"
                                                        />
                                                        <p className="geofence-helper-text">
                                                            Set how frequently the user&apos;s location is refreshed on the map. Applies to iOS devices only.
                                                        </p>
                                                    </div>
                                                </div>
                                            )}

                                            {!isReadOnly && (
                                                <div className="geofence-update-btn geofence-update-btn-row">
                                                    <Button onClick={() => this.updateSettings(isIOS)}>
                                                        Save Changes
                                                    </Button>
                                                </div>
                                            )}
                                        </>
                                    )}
                                </div>
                                {trackingEnabled && (
                                    <>
                                        <Row className={css(styles.rowsStyle)}>
                                            <div className="geofence-locations-header">
                                                <div style={{ fontWeight: 700 }}>Safe Locations</div>
                                                {!isReadOnly &&
                                                    <div style={{ padding: "10px" }}>
                                                        <Button
                                                            variant="primary"
                                                            title="Add New Safe Location"
                                                            onClick={this.handleGeofenceDialog}
                                                        >
                                                            {/* <img src="/images/add_icon_black.png" alt="new" /> */}
                                                            <span style={{ paddingRight: "5px" }}><img
                                                                alt="addNew"
                                                                src="/images/add_icon.png"
                                                            /></span>
                                                            {"Add New Safe Location"}
                                                        </Button>
                                                    </div>}
                                            </div>
                                            <div><hr style={{ margin: "0em 0em 1em" }} /></div>
                                            {this.state.geoLocations.map((location) =>
                                                <Col xs={12} sm={6} xl={4} className="geofence-location-card-col" key={location.id || location.locationName}>
                                                    <Card style={{ width: "100%" }}>
                                                        <Card.Header style={{ padding: "10px" }}>
                                                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: "8px" }}>
                                                                <span className="geofence-location-name">{location.locationName}</span>
                                                                {!isReadOnly &&
                                                                    <div>
                                                                        <span
                                                                            title="Edit"
                                                                            className={css(
                                                                                styles.imgStyle
                                                                            )}
                                                                            style={{ paddingRight: "10px" }}
                                                                            onClick={() => this.handleUpdateModal(location)}
                                                                        >
                                                                            <FontAwesomeIcon
                                                                                icon={faEdit}
                                                                                size=""
                                                                                style={{ color: "green" }}
                                                                            />
                                                                        </span>
                                                                        <span
                                                                            title="Delete"
                                                                            className={css(
                                                                                styles.imgStyle
                                                                            )}
                                                                            onClick={() => this.openDeleteModal(location)}
                                                                        >
                                                                            <FontAwesomeIcon
                                                                                icon={faTrashAlt}
                                                                                size=""
                                                                                style={{ color: "#c20f33" }}
                                                                            />
                                                                        </span>
                                                                    </div>}
                                                            </div>
                                                        </Card.Header>
                                                        <Card.Body style={{ padding: "10px", textAlign: "center" }}>
                                                            {location.fenceType === "CIRCLE" && (
                                                                <GeofenceCircleArea
                                                                    zoom={15}
                                                                    center={location.geoFenceData?.center}
                                                                    radius={location.geoFenceData?.radius}
                                                                    height={"200px"}
                                                                //clearClick={clear}
                                                                />
                                                            )}

                                                            {location.fenceType === "RECTANGLE" && (
                                                                <GeofenceRectangleArea
                                                                    zoom={15}
                                                                    height={"200px"}
                                                                    bounds={location.geoFenceData}
                                                                // clearClick={clear}
                                                                />
                                                            )}
                                                            {/* <h4 class="font-up font-bold deep-purple-text mb-3"><strong>Regular map</strong></h4> */}
                                                            <div style={{ paddingTop: "10px", textAlign: "left" }}>
                                                                <div className={css(styles.cardDiv)}>
                                                                    <div className={css(styles.cardLabel)}>{"Alert Type :"}</div>
                                                                    <div className={css(styles.cardLabelValue)}>{location.fenceAlertType === "IN_FENCE" ? `When entering the specified location` : 'When outside the specified location'}</div>
                                                                </div>
                                                                {location.monitoringMode === "ALWAYS" ? (
                                                                    <div className={css(styles.cardDiv)}>
                                                                        <div className={css(styles.cardLabel)}>{"Always On :"}</div>
                                                                        <div className={css(styles.cardLabelValue)}>{"Yes"}</div>
                                                                    </div>
                                                                ) : (
                                                                    <>
                                                                        <div className={css(styles.cardDiv)}>
                                                                            <div className={css(styles.cardLabel)}>{"Alert Days :"}</div>
                                                                            <div className={css(styles.cardLabelValue)}>
                                                                                {this.fetchAlertDays(location)}
                                                                            </div>
                                                                        </div>
                                                                        <div className={css(styles.cardDiv)}>
                                                                            <div className={css(styles.cardLabel)}>{"Alert Time :"}</div>
                                                                            <div className={css(styles.cardLabelValue)}>{`From ${moment(location.fenceAlertTiming?.[0]?.startTime, "hh:mm").format("hh:mm A")}  To  ${moment(location.fenceAlertTiming?.[0]?.endTime, "hh:mm").format("hh:mm A")}`}</div>
                                                                        </div>
                                                                    </>
                                                                )}
                                                            </div>
                                                        </Card.Body>
                                                    </Card>
                                                </Col>)}

                                            {/* <Col md={3} style={{ marginBottom: "1em" }}>
                                        <div style={{ marginTop: "27px", padding: "5px" }}>{""}</div>
                                        <Card>
                                            <Card.Body style={{ padding: "5px" }}>
                                                <Button
                                                    className={css(styles.buttonStyle)}
                                                    onClick={this.handleGeofenceDialog}
                                                >
                                                    <span><img
                                                        alt="addNew"
                                                        src="/images/add_blue_icn@2x.png"
                                                    /></span><br />
                                                    {"Add New Safe Location"}
                                                </Button>
                                            </Card.Body>
                                        </Card>
                                    </Col> */}
                                        </Row>
                                    </>
                                )}
                                    </>
                                )}
                            </div>
                        </Col>
                    </Row>
                    <Footer />
                </div>
            </container >
        );
    }
}
export default connect(
    (store) => {
        return {
            //token: store.appstate.jwtToken,
            geoLocationSettings: store.dashboard.geoLocationSettings,
            user: store.user,
            appModules: store.dashboard.appModules,
        };
    },
    (dispatch) => {
        return {
            setGeoLocationSettings: (geoLocationSettings) => {
                dispatch({
                    type: "SET_GEO_LOCATION_SETTINGS",
                    payload: { geoLocationSettings },
                });
            },
        };
    }
)(withRouter(GeofenceSettings));
